import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { MessageSquare, X } from 'lucide-react';
import api from '../../api/client';
import { avvisaTicketCambiati } from '../../utils/useTicketDaLeggere';

// Avviso a schermo per lo staff (21/10 titolare: niente email, solo notifiche a schermo).
// Ogni minuto guarda le richieste in attesa che si possono prendere (proprie o di nessuno, negli argomenti
// del proprio ruolo): se ne è arrivata una nuova compare un riquadro in basso a destra.
const CHIAVE = 'supporto_ultimo_visto';
export default function AvvisoSupporto({ attivo }) {
  const [avviso, setAvviso] = useState(null);
  const nav = useNavigate();
  const { pathname } = useLocation();
  const timer = useRef(null);
  useEffect(() => {
    if (!attivo) return;
    let vivo = true;
    const controlla = () => api.get('/tickets/conteggio').then(r => {
      if (!vivo) return;
      const { da_leggere: n, ultimo } = r.data || {};
      let visto = null;
      try { visto = sessionStorage.getItem(CHIAVE); } catch {}
      if (n > 0 && ultimo && (!visto || ultimo > visto)) {
        try { sessionStorage.setItem(CHIAVE, ultimo); } catch {}
        setAvviso({ n, nuovo: !!visto });
        avvisaTicketCambiati();
        clearTimeout(timer.current);
        timer.current = setTimeout(() => setAvviso(null), 15000);
      }
    }).catch(() => {});
    controlla();
    const t = setInterval(controlla, 60000);
    return () => { vivo = false; clearInterval(t); clearTimeout(timer.current); };
  }, [attivo]);
  // nella pagina Supporto l'elenco si aggiorna da solo: il riquadro non serve
  if (!avviso || pathname.startsWith('/supporto')) return null;
  return (
    <div role="status" style={s.box} onClick={() => { setAvviso(null); nav('/supporto'); }}>
      <MessageSquare size={20} color="#F4600C" style={{ flexShrink: 0 }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 800 }}>{avviso.nuovo ? 'Nuovo messaggio di supporto' : 'Supporto'}</div>
        <div style={{ fontSize: '13px', color: 'var(--text-muted)' }}>{avviso.n === 1 ? '1 richiesta aspetta una risposta' : `${avviso.n} richieste aspettano una risposta`} · tocca per aprire</div>
      </div>
      <button style={s.x} onClick={e => { e.stopPropagation(); setAvviso(null); }} aria-label="Chiudi"><X size={16} /></button>
    </div>
  );
}
const s = {
  box: { display: 'flex', gap: '12px', alignItems: 'center', width: 'min(360px, calc(100vw - 32px))', background: 'var(--bg-card)', color: 'var(--text)', border: '1px solid var(--border)', borderLeft: '4px solid #F4600C', borderRadius: '14px', padding: '12px 14px', boxShadow: '0 12px 32px rgba(0,0,0,.18)', cursor: 'pointer', pointerEvents: 'auto' },
  x: { border: 'none', background: 'none', cursor: 'pointer', color: 'var(--text-dim)', padding: '4px', display: 'flex' },
};
